




























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { scrollTo } from '../../common/utils/scroll-to';

interface PaginationConfig {
  pageSizes?: Array<number>,
  background?: boolean,
  autoScroll?: boolean,
  hidden?: boolean,
  size?: string,
  isJumper?: boolean,
  isSizes?: boolean,
  isPageNum?: boolean
}

@Component({
  name: 'mcPagination'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private config: PaginationConfig;
  @Prop({ required: true }) private total!: number;
  @Prop({ default: 1 }) private page!: number;
  @Prop({ default: 5 }) private pageSize!: number;
  // @Prop({ default: () => [5, 10, 20, 50, 100] }) private pageSizes!: number[];
  // @Prop({ default: true }) private background!: boolean;
  // @Prop({ default: true }) private autoScroll!: boolean;
  // @Prop({ default: false }) private hidden!: boolean;
  // @Prop({ default: 'large' }) private size!: string;
  // @Prop({ default: true }) private isJumper!: boolean;
  // @Prop({ default: true }) private isSizes!: boolean;
  // @Prop({ default: true }) private isPageNum!: boolean;
  defaultConfig: PaginationConfig = {
    pageSizes: [5, 10, 20, 50, 100],
    background: true,
    autoScroll: true,
    hidden: false,
    size: 'large',
    isJumper: true,
    isSizes: true,
    isPageNum: true
  };

  created() {
    this.initPaginatinConfig();
  }

  // 检测值
  @Watch("config")
  onConfigChanged(val: PaginationConfig) {
    this.initPaginatinConfig();
  }

  get lastPageNum() {
    return Math.ceil(this.total / this.pageSize)
  }

  get firstPageBtnDisabled() {
    return this.currentPage === 1;
  }

  get lastPageBtnDisabled() {
    return this.currentPage === this.lastPageNum;
  }

  toFirstPage() {
    this.currentPage = 1;
    this.handleCurrentChange(this.currentPage);
  }

  toLastPage() {
    this.currentPage = this.lastPageNum;
    this.handleCurrentChange(this.lastPageNum);
  }

  get currentPage() {

    return this.page;
  }

  set currentPage(value: any) {
    this.$emit('update:page', parseInt(value || 1));
  }

  get currentPageSize() {
    return this.pageSize;
  }

  set currentPageSize(value) {
    this.$emit('update:pageSize', value);
  }

  handleSizeChange(value: number) {
    setTimeout(() => {
      this.$emit('on-change', { page: this.currentPage, pageSize: value });
      if (this.config.autoScroll) {
        scrollTo(0, 800);
      }
    })
  }

  handleCurrentChange(value: number) {
    if (value <= 1) {
      this.currentPage = 1
    } else if (this.lastPageNum < value) {
      this.currentPage = this.lastPageNum
    }
    this.$emit('on-change', { page: value, pageSize: this.pageSize });
    if (this.config.autoScroll) {
      scrollTo(0, 800);
    }
  }

  initPaginatinConfig() {
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) this.config[key] = this.defaultConfig[key];
    });
  }
}
